import(/* webpackMode: "eager" */ "/Users/poojaagrawal/Projects/itellisecure/src/app/phishing/page.tsx");
